export const normalizeFilterValue = (value: unknown): unknown => {
    if (Array.isArray(value) && value.length === 0) {
        return undefined;
    }
    if (value === '') {
        return undefined;
    }
    return value;
};
